import { render, staticRenderFns } from "./StudentTable.vue?vue&type=template&id=03c3e5b1"
import script from "./StudentTable.vue?vue&type=script&lang=js"
export * from "./StudentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports